var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('nuxt')],1),_vm._v(" "),_c('portal-target',{attrs:{"name":"outside"}}),_vm._v(" "),_c('portal-target',{attrs:{"name":"outside-front"}}),_vm._v(" "),_c('snack-bar-container')],1)}
var staticRenderFns = []

export { render, staticRenderFns }